import { render, staticRenderFns } from "./warningNoteIcon.vue?vue&type=template&id=0450012a&"
import script from "./warningNoteIcon.vue?vue&type=script&lang=js&"
export * from "./warningNoteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports